import { render, staticRenderFns } from "./OrderWidget.vue?vue&type=template&id=545bf15d&scoped=true"
import script from "./OrderWidget.vue?vue&type=script&lang=js"
export * from "./OrderWidget.vue?vue&type=script&lang=js"
import style0 from "./OrderWidget.vue?vue&type=style&index=0&id=545bf15d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "545bf15d",
  null
  
)

export default component.exports